// extracted by mini-css-extract-plugin
export default {"shopSmallContainer":"SellerSearchPage_shopSmallContainer__Un31B","fixWidthContainer":"SellerSearchPage_fixWidthContainer__DAO-e","sellerCards":"SellerSearchPage_sellerCards__JmNWM"};